const FAQ = [
  {
    id: "1",
    question: "Design and Creative",
    answer:
      "Service Rendering is a platform designed to connect skilled service providers, such as plumbers, electricians, and handymen, with individuals and businesses needing reliable services. Users can search for and connect directly with trusted professionals in their area, while service providers gain access to a stream of local job leads.",
  },
  {
    id: "2",
    question: "Who can use this app?",
    answer:
      "Service Rendering  is for anyone in need of skilled service providers, as well as professionals offering services in various fields like plumbing, electrical works, music instructors, private teachers, hairdressing , clothes mending, caterers, Barbing , Food vendors/ catering services, Teaching services electronic repairs, event planning, music instructor, DJ, instrumentalist, MC, painting, Sports Instructors, immigration services, Real estate services and any  type of  services. Are you skilled in any area. Then you can turn your skill into cash or are you looking for   expert to give you a top notch service without hassle , then This is the place to be",
  },
  {
    id: "3",
    question: "⁠How do I find a service provider on the app?",
    answer:
      "Simply browse the app’s listings by service type, enter your location, and you’ll see a selection of qualified professionals nearby. Each provider has a profile with ratings and reviews, helping you make an informed choice.",
  },
  {
    id: "4",
    question: "How can I join as a service provider?",
    answer:
      "If youre a skilled professional, you can sign up as a service provider on the app. Once registered, you’ll gain access to job leads in your area, allowing you to connect with users who need your expertise.",
  },
  {
    id: "5",
    question: "What types of services can I find on the app?",
    answer:
      "You can find a wide range of services on the app, including plumbing, electrical work, handyman services, and more. The app is designed to support a variety of professional skills, making it easy to locate the help you need.",
  },
  {
    id: "6",
    question: " ⁠How does the app ensure the quality of service providers?",
    answer:
      "The app provides profiles for each service provider, including user ratings and reviews. This system helps maintain a high standard, allowing users to choose trusted professionals based on real experiences.",
  },
  {
    id: "7",
    question: "Is the app easy to use?",
    answer:
      "Yes, the app is designed with a user-friendly interface, making it easy for both service providers and users to navigate. You can search for providers, manage bookings, and communicate easily—all in one place.",
  },
  {
    id: "8",
    question:
      " ⁠How do I communicate with a service provider once I’ve chosen one?",
    answer:
      "Once you select a provider, the app offers messaging tools that allow you to communicate directly. You can discuss job details, schedules, and any special requests.",
  },
  {
    id: "9",
    question: "What should I do if I encounter an issue with the app?",
    answer:
      "If you experience any issues, you can reach out to our support team through the app. We’re here to assist you and ensure a smooth experience.",
  },
  {
    id: "10",
    question: "⁠Is there a fee to use the app?",
    answer:
      "The app is free to download and browse. Service providers may have different pricing for their services, which you can review before booking.",
  },
];

export default FAQ;
